<template>
  <div class="wlx-site-basic-info-main clearfix">
    <el-form  label-width="80px">
      <el-form-item label="用户名">
        <el-input v-model="userName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="displayName"></el-input>
      </el-form-item>
      <el-form-item label="头像">
        <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="mobile"></el-input>
      </el-form-item>
      <el-form-item label="管理协会">
        <el-input v-model="siteTitle" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="所属省市">
        <el-select v-model="province" placeholder="请选择省" @change="getCityList">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="city" placeholder="请选择市">
          <el-option
            v-for="item in cityList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="updateSite">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      siteTitle: '',
      province: '',
      city: '',
      userName: '',
      displayName: '',
      avatorUrl: '',
      mobile: '',
      files:[],
      fileList: [],
      MedalIconUrl:'',
      AvatorUrl:'',
      options: [],
      cityList: [],
       urlAliyunOSS: '/api/design/osssign/getsign',
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  components: {
    imageUpload
  },
  created() {
    
    this.getInfo();
    this.getAllProvinceList();
  },
  watch:{
     AvatorUrl: function(val) {
       console.log(val);
    },
  },
  methods: {
    getInfo(){
      var that = this;
      this.$http
        .post("/api/XOrg/SiteInfo/getSiteInfo", {})
        .then(function(rst) {
          if (rst.code === 1 && rst.siteInfo) {
            that.userName = rst.siteInfo.userName;
            that.displayName = rst.siteInfo.displayName;
            that.avatorUrl = rst.siteInfo.avatorUrl;
            that.mobile = rst.siteInfo.mobile;
            that.siteTitle = rst.siteInfo.siteTitle;
            that.province = rst.siteInfo.province;
            that.city = rst.siteInfo.city;
            that.InfoCity();
          }else{
            that.$message.warning(rst.msg || '');
          }
        });
    },
    updateSite(){
      var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if(this.mobile==''){
          alert("请输入手机号码");
      }else if(!reg.test(this.mobile)){
          alert("手机格式不正确");
      }
      var that = this;
      this.$http
        .post("/api/XOrg/SiteInfo/updateSite", {
          siteTitle: that.siteTitle,
          province:that.province,
          city:that.city,
          avatorUrl: that.avatorUrl,
          displayName: that.displayName,
          mobile: that.mobile
        })
        .then(function(rst) {
          if (rst.code === 1) {
            that.$message.success(rst.msg);
          }else{
            that.$message.warning(rst.msg);
          }
        });
    },
    //获取省市
    getAllProvinceList() {
      this.$http
        .post("/api/XOrg/AssociationSites/getAllProvinceList", {})
        .then(rst => {
          if (rst.code > 0) {
            this.options = rst.province;
          }
        });
    },
    getCityList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getCityList", {
          province: that.province
        })
        .then(rst => {
          if (rst.code > 0) {
            that.cityList = rst.cityList;
            that.city = rst.cityList.length > 0 ? rst.cityList[0].value:"";
          }
        });
    },
    InfoCity(){
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getCityList", {
          province: that.province
        })
        .then(rst => {
          if (rst.code > 0) {
            that.cityList = rst.cityList;
          }
        });
    }
  },
};
</script>

<style lang="scss">
.wlx-site-basic-info-main{
  width: 50%;
}
</style>
